export default __webpack_public_path__ + "static/media/LogoKaoba.8f3d5c89.svg";